import { render, staticRenderFns } from "./MysteryBox.vue?vue&type=template&id=904919ac&scoped=true"
import script from "./MysteryBox.vue?vue&type=script&lang=js"
export * from "./MysteryBox.vue?vue&type=script&lang=js"
import style0 from "./MysteryBox.vue?vue&type=style&index=0&id=904919ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904919ac",
  null
  
)

export default component.exports